import React from "react";
export function InvestmentIcon(props) {
  return props.type === "research" ? (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0H48C56.8366 0 64 7.16344 64 16V48C64 56.8366 56.8366 64 48 64H16C7.16344 64 0 56.8366 0 48V16Z"
        fill="#373737"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.6583 24.175C46.1139 24.6306 46.1139 25.3693 45.6583 25.8249L34.575 36.9082C34.1193 37.3638 33.3807 37.3638 32.925 36.9082L27.9167 31.8998L19.9916 39.8249C19.536 40.2805 18.7973 40.2805 18.3417 39.8249C17.8861 39.3693 17.8861 38.6306 18.3417 38.175L27.0917 29.425C27.5473 28.9693 28.286 28.9693 28.7416 29.425L33.75 34.4333L44.0084 24.175C44.464 23.7193 45.2027 23.7193 45.6583 24.175Z"
        fill="#E9E9E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6665 24.9999C36.6665 24.3556 37.1888 23.8333 37.8332 23.8333H44.8332C45.4775 23.8333 45.9998 24.3556 45.9998 24.9999V31.9999C45.9998 32.6443 45.4775 33.1666 44.8332 33.1666C44.1888 33.1666 43.6665 32.6443 43.6665 31.9999V26.1666H37.8332C37.1888 26.1666 36.6665 25.6443 36.6665 24.9999Z"
        fill="#E9E9E9"
      />
    </svg>
  ) : props.type === "community" ? (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0H48C56.8366 0 64 7.16344 64 16V48C64 56.8366 56.8366 64 48 64H16C7.16344 64 0 56.8366 0 48V16Z"
        fill="#373737"
      />
      <path
        d="M26.0498 21.3352H32.3164C32.5194 21.3355 32.6836 21.5003 32.6836 21.7034V24.4963H39.9932C40.1964 24.4963 40.3613 24.6613 40.3613 24.8645V41.929H42.7031C42.9063 41.929 43.0713 42.0939 43.0713 42.2971C43.0711 42.5002 42.9062 42.6652 42.7031 42.6653H21.7031C21.5 42.6653 21.3351 42.5002 21.335 42.2971C21.335 42.0939 21.4999 41.929 21.7031 41.929H24.0449V24.8645C24.045 24.6613 24.2099 24.4963 24.4131 24.4963H25.6816V21.7034C25.6816 21.5002 25.8466 21.3352 26.0498 21.3352ZM24.7803 41.929H29.125V37.0198H28.1953C27.9921 37.0198 27.8271 36.8548 27.8271 36.6516C27.8272 36.4484 27.9921 36.2834 28.1953 36.2834H36.2109C36.4142 36.2834 36.5791 36.4484 36.5791 36.6516C36.5791 36.8548 36.4142 37.0198 36.2109 37.0198H35.2803V41.929H39.625V25.2327H24.7803V41.929ZM29.8613 41.929H34.5449V37.0198H29.8613V41.929ZM28.9854 32.6145H30.001C30.2042 32.6145 30.3691 32.7795 30.3691 32.9827C30.3689 33.1857 30.2041 33.3499 30.001 33.3499H28.9854C28.7823 33.3499 28.6174 33.1857 28.6172 32.9827C28.6172 32.7795 28.7822 32.6145 28.9854 32.6145ZM34.3486 32.6145H35.3643C35.5675 32.6145 35.7324 32.7794 35.7324 32.9827C35.7322 33.1857 35.5674 33.3499 35.3643 33.3499H34.3486C34.1455 33.3499 33.9807 33.1857 33.9805 32.9827C33.9805 32.7794 34.1454 32.6145 34.3486 32.6145ZM28.9854 29.2268H30.001C30.2041 29.2268 30.369 29.3919 30.3691 29.595C30.3691 29.7982 30.2042 29.9631 30.001 29.9631H28.9854C28.7822 29.9631 28.6172 29.7982 28.6172 29.595C28.6173 29.3919 28.7822 29.2268 28.9854 29.2268ZM34.3486 29.2268H35.3643C35.5674 29.2268 35.7323 29.3919 35.7324 29.595C35.7324 29.7982 35.5675 29.9631 35.3643 29.9631H34.3486C34.1454 29.9631 33.9805 29.7982 33.9805 29.595C33.9806 29.3919 34.1455 29.2268 34.3486 29.2268ZM26.418 24.4963H31.9482V22.0715H26.418V24.4963Z"
        fill="#E9E9E9"
        stroke="#E9E9E9"
        strokeWidth="1.07049"
      />
    </svg>
  ) : props.type === "paid" ? (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0H48C56.8366 0 64 7.16344 64 16V48C64 56.8366 56.8366 64 48 64H16C7.16344 64 0 56.8366 0 48V16Z"
        fill="#373737"
      />
      <g clipPath="url(#clip0_4436_808)">
        <path
          d="M32 19.1667V44.8334"
          stroke="#E9E9E9"
          strokeWidth="2.59778"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.8333 23.8333H29.0833C28.0004 23.8333 26.9618 24.2635 26.196 25.0292C25.4302 25.795 25 26.8336 25 27.9166C25 28.9996 25.4302 30.0382 26.196 30.8039C26.9618 31.5697 28.0004 31.9999 29.0833 31.9999H34.9167C35.9996 31.9999 37.0382 32.4301 37.804 33.1959C38.5698 33.9617 39 35.0003 39 36.0833C39 37.1662 38.5698 38.2048 37.804 38.9706C37.0382 39.7364 35.9996 40.1666 34.9167 40.1666H25"
          stroke="#E9E9E9"
          strokeWidth="2.59778"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4436_808">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(18 18)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <></>
  );
}
export default InvestmentIcon;
